module.exports = __webpack_public_path__ + "static/img01-e2d92272355c41fb444db5da70e28590.jpg";